export default {"src":"/_next/static/media/welcome-mat.b06ccf11.svg","height":173,"width":460};